export default __webpack_public_path__ + "static/media/Tasset of the Chaos Agent.f9b2a386.jpg";